<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="350">
      <template v-slot:activator="{ on }">
        <v-btn block :loading="dialog" color="warning" v-on="on"
          >To Account (OUT)</v-btn
        >
      </template>
      <v-card>
        <v-card-title class="teal headline">Transfer to Account</v-card-title>
        <v-card-text>
          <v-form ref="withDrowform" v-model="valid">
            <!-- <p
              class="font-weight-black text-center black--text"
              v-if="withdrow.amount"
            >
              {{ withdrow.amountType | MoneySigns }}
              {{ withdrow.amount.toLocaleString() }}
            </p>

            <v-text-field
              v-model.number.trim="withdrow.amount"
              autofocus
              :rules="[v => !!v || 'Amount is required']"
              name="withdrowAmount"
              label="Transfer Amount"
              type="number"
              prepend-icon="mdi-cash-multiple"
            ></v-text-field> -->

            <BaseNumInput
              class="mt-3"
              autofocus
              outlined
              dense
              :rules="[v => !!v || 'Amount is required']"
              append-icon="mdi-cash-multiple"
              :prefix="withdrow.amountType | MoneySigns"
              v-model.trim="withdrow.amount"
              label="Transfer Amount"
            ></BaseNumInput>

            <div v-show="withdrow.amount > 0">
              <v-select
                outlined
                dense
                append-icon="mdi-cash"
                v-model.trim="withdrow.amountType"
                :items="GetCashTypes"
                :rules="[v => !!v || 'Cash Type is required']"
                label="Cash Type"
                required
              ></v-select>

              <SelectClient
                :current="AccountNumber"
                :account="withdrow.ToAccount"
                :value="withdrow.Reciever"
                @selected="selectHandlar"
              />

              <v-text-field
                outlined
                dense
                v-model="withdrow.date"
                :rules="[v => !!v || 'Withdrow Date is required']"
                required
                name="withdrowFild"
                label="Transfer Date"
                type="date"
              ></v-text-field>

              <v-textarea
                outlined
                v-model="withdrow.details"
                :rules="[v => !!v || 'Details is required']"
                append-icon="mdi-message-text-outline"
                label="Details"
                clearable
                counter="100"
                auto-grow
                row-height="2"
              ></v-textarea>
            </div>
          </v-form>
          <p class="text-center mt-2 red--text">{{ ErrorMsg }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="clicked" color="green darken-1" text @click="close"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!valid"
            :loading="clicked"
            color="green darken-1"
            text
            @click="OnDeposit"
            >Withdraw</v-btn
          >
        </v-card-actions>

        <!-- <p>{{ AccountNumber }}</p> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    SelectClient: () => import("./selectTranAcc"),
  },
  props: {
    AccountNumber: [Number],
    SenderName: [String],
    FinishedWithdrow: [Function],
  },
  data() {
    return {
      valid: true,
      dialog: false,
      ErrorMsg: "",
      clicked: false,

      withdrow: {
        amount: null,
        amountType: null,
        AccountNumber: "",
        ToAccount: "",
        Reciever: "",
        details: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.withDrowform.reset();
      this.withdrow.ToAccount = "";
      this.withdrow.Reciever = "";
      this.withdrow.date = this.Current().date;
    },
    selectHandlar({ FullName, AccountNumber }) {
      this.withdrow.ToAccount = AccountNumber;
      this.withdrow.Reciever = FullName;
    },
    OnDeposit() {
      this.ErrorMsg = "";
      if (this.$refs.withDrowform.validate()) {
        this.clicked = true;
        this.withdrow.time = this.Current().time;
        this.withdrow.AccountNumber = this.AccountNumber;
        this.withdrow.SenderName = this.SenderName;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/qarash/toAccount",
            data: this.withdrow,
          })
          .then(result => {
            this.clicked = false;
            this.close();
            // console.log(result);
            this.FinishedWithdrow(result.data);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
          });
      }
    },
  },
  mounted() {
    this.withdrow.date = this.Current().date;
  },
};
</script>
